import { memo } from 'react'
import { DialogContent, Stack } from '@collaborate-health/uikit'
import { SharingDialogStage } from '@tabeeb/modules/contentSharings/types'
import Step from './Step'

interface ContentProps {
  stages: SharingDialogStage[]
  currentStageIndex: number
  setCurrentStageIndex: (index: number) => void
  onClose: () => void
}

const Content: React.FC<ContentProps> = ({ stages, currentStageIndex }) => {
  const currentStage = stages[currentStageIndex]
  if (!currentStage) {
    return null
  }

  return (
    <DialogContent>
      <Stack spacing={2}>
        {currentStage.steps.map((step, index) => (
          <Step step={step} stepIndex={index} currentStage={currentStage} key={step.id} />
        ))}
      </Stack>
    </DialogContent>
  )
}

export default memo(Content)

